module.exports = __webpack_public_path__ + "static/media/me.01883a21.jpg";